"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Model = exports.decodeModel = exports.Medium = void 0; /// Medium is inherited from M-Bus

var Medium;

(function (Medium) {
  Medium[Medium["Other"] = 0] = "Other";
  Medium[Medium["Oil"] = 1] = "Oil";
  Medium[Medium["Electricity"] = 2] = "Electricity";
  Medium[Medium["Gas"] = 3] = "Gas";
  Medium[Medium["Heat"] = 4] = "Heat";
  Medium[Medium["Steam"] = 5] = "Steam";
  Medium[Medium["WarmWater"] = 6] = "WarmWater";
  Medium[Medium["Water"] = 7] = "Water";
  Medium[Medium["HCA"] = 8] = "HCA";
  Medium[Medium["CompressedAir"] = 9] = "CompressedAir";
  Medium[Medium["Cooling"] = 10] = "Cooling";
  Medium[Medium["CoolingMode2"] = 11] = "CoolingMode2";
  Medium[Medium["HeatMode2"] = 12] = "HeatMode2";
  Medium[Medium["HeatCoolingLoad"] = 13] = "HeatCoolingLoad";
  Medium[Medium["Bus"] = 14] = "Bus";
  Medium[Medium["Unknown"] = 15] = "Unknown";
  Medium[Medium["ReservedConsumption0"] = 16] = "ReservedConsumption0";
  Medium[Medium["ReservedConsumption1"] = 17] = "ReservedConsumption1";
  Medium[Medium["ReservedConsumption2"] = 18] = "ReservedConsumption2";
  Medium[Medium["ReservedConsumption3"] = 19] = "ReservedConsumption3";
  Medium[Medium["CalorificValue"] = 20] = "CalorificValue";
  Medium[Medium["HotWater"] = 21] = "HotWater";
  Medium[Medium["ColdWater"] = 22] = "ColdWater";
  Medium[Medium["DualWater"] = 23] = "DualWater";
  Medium[Medium["Pressure"] = 24] = "Pressure";
  Medium[Medium["AdConverter"] = 25] = "AdConverter";
  Medium[Medium["SmokeDetector"] = 26] = "SmokeDetector";
  Medium[Medium["RoomSensor"] = 27] = "RoomSensor";
  Medium[Medium["GasDetector"] = 28] = "GasDetector";
  Medium[Medium["ReservedSensors1"] = 29] = "ReservedSensors1";
  Medium[Medium["ReservedSensors2"] = 30] = "ReservedSensors2";
  Medium[Medium["ReservedSensors3"] = 31] = "ReservedSensors3";
  Medium[Medium["Breaker"] = 32] = "Breaker";
  Medium[Medium["Valve"] = 33] = "Valve";
  Medium[Medium["ReservedSwitching0"] = 34] = "ReservedSwitching0";
  Medium[Medium["ReservedSwitching1"] = 35] = "ReservedSwitching1";
  Medium[Medium["ReservedSwitching2"] = 36] = "ReservedSwitching2";
  Medium[Medium["CustomerUnit"] = 37] = "CustomerUnit";
  Medium[Medium["WasteWater"] = 40] = "WasteWater";
  Medium[Medium["Garbage"] = 41] = "Garbage";
  Medium[Medium["CarbonDioxide"] = 42] = "CarbonDioxide";
  Medium[Medium["Environmental"] = 43] = "Environmental";
  Medium[Medium["Systemd"] = 48] = "Systemd";
  Medium[Medium["Inverter"] = 80] = "Inverter";
})(Medium = exports.Medium || (exports.Medium = {}));

;

exports.decodeModel = function (m) {
  if (typeof m === "string") {
    return new Model("", m, "", Medium.Other, 0);
  }

  var mfg = "";
  var model = "";
  var variant = "";
  var medium = Medium.Other;
  var version = 0;

  if (m != undefined && m.manufacturer != undefined) {
    mfg = m.manufacturer;
  }

  if (m != undefined && m.model != undefined) {
    model = m.model;
  }

  if (m != undefined && m.variant != undefined) {
    variant = m.variant;
  }

  if (m != undefined && m.medium != undefined) {
    medium = m.medium;
  }

  if (m != undefined && m.version != undefined) {
    version = m.version;
  }

  return new Model(mfg, model, variant, medium, version);
};

var Model =
/** @class */
function () {
  function Model(manufacturer, model, variant, medium, version) {
    this.manufacturer = manufacturer;
    this.model = model;
    this.variant = variant;
    this.medium = medium;
    this.version = version;
  }
  /** hash can be used to create a stable unique version based on model.
   * This is currently used for Com devices whose prefix is not used in communication
   * but used for consistent storage */


  Model.prototype.hash = function () {
    var input = this.manufacturer + " " + this.model;
    var hash = 0;

    for (var i = 0; i < input.length; i++) {
      hash = hash + input.charCodeAt(i);
    }

    return hash % 255;
  };
  /** generateVersion generates a stably hashed version based on manufacturer and model */


  Model.prototype.generateVersion = function () {
    this.version = this.hash();
  };

  Model.prototype.encode = function () {
    var rawModel = {
      medium: this.medium,
      version: this.version
    };

    if (this.manufacturer.length > 0) {
      rawModel["manufacturer"] = this.manufacturer;
    }

    if (this.model.length > 0) {
      rawModel["model"] = this.model;
    }

    if (this.variant.length > 0) {
      rawModel["variant"] = this.variant;
    }

    return rawModel;
  };

  return Model;
}();

exports.Model = Model;